import Section from 'pxc-editor-core/entities/Section';
import { RECTANGLE, ELLIPSE } from '@/constants';
import { getShieldBySelectedSection, checkSpecialSymbol, insertSymbolAvailable } from '@/helpers';

export default ({ sections, sectionsSelection, selectedSection, pages }) => {
  const sectionsAvailable = !!Object.keys(sections).length;
  const isInsertSymbolAvailable = insertSymbolAvailable();
  if (sectionsAvailable) {
    const selectedSections = Object.values(sections).filter(section => !!sectionsSelection[section.id]);
    if (selectedSections.length === 1) {
      const [section] = selectedSections;
      const shield = getShieldBySelectedSection({ pages, selectedSection: section });
      const isShieldMatrix = !!shield?.isMatrix;
      if (isShieldMatrix) {
        // console.log('[Case-1]: a shield is matrix with one selected section');
        return {
          isTextOptionAvailable: Section.contentIsEmpty(section) || !!section['text'],
          isAlignmentOptionAvailable: Section.contentIsEmpty(section) || !!section['text'] || !!section['glyph'] || !!section['image'],
          isSectionsOptionAvailable: false,
          isRotateAndFlipOptionAvailable: !!section['shape'] ? ![RECTANGLE, ELLIPSE].includes(section.shape.name) : true,
          isFillAndLineOptionAvailable: !section['shape'],
          isMatrixOptionAvailable: true,
          isSeparatorOptionAvailable: true,
          isImageOptionAvailable: !!section['image'],
          isRectangleShapeOptionAvailable: !!section['shape'] && section.shape.name === RECTANGLE,
          isEllipseShapeOptionAvailable: !!section['shape'] && section.shape.name === ELLIPSE,
          isGraphicOptionAvailable: !!section['code'] || (!!section['glyph'] && !checkSpecialSymbol(section)) || !!section['image'],
          isInsertSymbolAvailable
        }; 
      }
      // console.log('[Case-2]: a shield is not matrix with one selected section');
      return {
        isTextOptionAvailable: Section.contentIsEmpty(section) || !!section['text'],
        isAlignmentOptionAvailable: Section.contentIsEmpty(section) || !!section['text'] || !!section['glyph'] || !!section['image'],
        isSectionsOptionAvailable: true,
        isRotateAndFlipOptionAvailable: !!section['shape'] ? ![RECTANGLE, ELLIPSE].includes(section.shape.name) : true,
        isFillAndLineOptionAvailable: !section['shape'],
        isMatrixOptionAvailable: false,
        isSeparatorOptionAvailable: false,
        isImageOptionAvailable: !!section['image'],
        isRectangleShapeOptionAvailable: !!section['shape'] && section.shape.name === RECTANGLE,
        isEllipseShapeOptionAvailable: !!section['shape'] && section.shape.name === ELLIPSE,
        isGraphicOptionAvailable: !!section['code'] || (!!section['glyph'] && !checkSpecialSymbol(section)) || !!section['image'],
        isInsertSymbolAvailable
      }; 
    } else if (selectedSections.length > 1) {
      const isShieldMatrix = selectedSections.every(section => !!getShieldBySelectedSection({ pages, selectedSection: section })?.isMatrix);
      if (isShieldMatrix) {
        // console.log('[Case-3]: a shield is matrix with multiple selected sections');
        return {
          isTextOptionAvailable: selectedSections.every(section => Section.contentIsEmpty(section) || !!section.text),
          isAlignmentOptionAvailable: selectedSections.every(section => !!section.code || !!section.shape) ? false : true,
          isSectionsOptionAvailable: false,
          isRotateAndFlipOptionAvailable: selectedSections.every(section => !!section.shape && [RECTANGLE, ELLIPSE].includes(section.shape.name)) ? false : true,
          isFillAndLineOptionAvailable: selectedSections.every(section => !!section.shape) ? false : true,
          isMatrixOptionAvailable: true,
          isSeparatorOptionAvailable: true,
          isImageOptionAvailable: selectedSections.every(section => !!section.image),
          isRectangleShapeOptionAvailable: selectedSections.every(section => !!section.shape && section.shape.name === RECTANGLE),
          isEllipseShapeOptionAvailable: selectedSections.every(section => !!section.shape && section.shape.name === ELLIPSE),
          isGraphicOptionAvailable: selectedSections.every(section => !!section['code'] || (!!section['glyph'] && !checkSpecialSymbol(section)) || !!section['image']),
          isInsertSymbolAvailable
        };
      } else if (selectedSection) {
        const section = selectedSection;
        const shield = getShieldBySelectedSection({ pages, selectedSection: section });
        const isShieldMatrix = !!shield?.isMatrix;
        if (isShieldMatrix) {
          // console.log('[Case-4]: a shield is a matrix with selected section(s)');
          return {
            isTextOptionAvailable: Section.contentIsEmpty(section) || !!section['text'],
            isAlignmentOptionAvailable: Section.contentIsEmpty(section) || !!section['text'] || !!section['glyph'] || !!section['image'],
            isSectionsOptionAvailable: false,
            isRotateAndFlipOptionAvailable: !!section['shape'] ? ![RECTANGLE, ELLIPSE].includes(section.shape.name) : true,
            isFillAndLineOptionAvailable: !section['shape'],
            isMatrixOptionAvailable: true,
            isSeparatorOptionAvailable: true,
            isImageOptionAvailable: !!section['image'],
            isRectangleShapeOptionAvailable: !!section['shape'] && section.shape.name === RECTANGLE,
            isEllipseShapeOptionAvailable: !!section['shape'] && section.shape.name === ELLIPSE,
            isGraphicOptionAvailable: !!section['code'] || (!!section['glyph'] && !checkSpecialSymbol(section)) || !!section['image'],
            isInsertSymbolAvailable
          }; 
        }
        // console.log('[Case-5]: a shield is not matrix with multiple sections');
        return {
          isTextOptionAvailable: Section.contentIsEmpty(section) || !!section['text'],
          isAlignmentOptionAvailable: Section.contentIsEmpty(section) || !!section['text'] || !!section['glyph'] || !!section['image'],
          isSectionsOptionAvailable: true,
          isRotateAndFlipOptionAvailable: !!section['shape'] ? ![RECTANGLE, ELLIPSE].includes(section.shape.name) : true,
          isFillAndLineOptionAvailable: !section['shape'],
          isMatrixOptionAvailable: false,
          isSeparatorOptionAvailable: false,
          isImageOptionAvailable: !!section['image'],
          isRectangleShapeOptionAvailable: !!section['shape'] && section.shape.name === RECTANGLE,
          isEllipseShapeOptionAvailable: !!section['shape'] && section.shape.name === ELLIPSE,
          isGraphicOptionAvailable: !!section['code'] || (!!section['glyph'] && !checkSpecialSymbol(section)) || !!section['image'],
          isInsertSymbolAvailable
        }; 
      }
      // console.log('[Case-6]: just shield(s) selected');
      return {
        isTextOptionAvailable: selectedSections.every(section => Section.contentIsEmpty(section) || !!section.text),
        isAlignmentOptionAvailable: selectedSections.every(section => !!section.code || !!section.shape) ? false : true,
        isSectionsOptionAvailable: true,
        isRotateAndFlipOptionAvailable: selectedSections.every(section => !!section.shape && [RECTANGLE, ELLIPSE].includes(section.shape.name)) ? false : true,
        isFillAndLineOptionAvailable: selectedSections.every(section => !!section.shape) ? false : true,
        isMatrixOptionAvailable: false,
        isSeparatorOptionAvailable: false,
        isImageOptionAvailable: selectedSections.every(section => !!section.image),
        isRectangleShapeOptionAvailable: selectedSections.every(section => !!section.shape && section.shape.name === RECTANGLE),
        isEllipseShapeOptionAvailable: selectedSections.every(section => !!section.shape && section.shape.name === ELLIPSE),
        isGraphicOptionAvailable: selectedSections.every(section => !!section['code'] || (!!section['glyph'] && !checkSpecialSymbol(section)) || !!section['image']),
        isInsertSymbolAvailable
      };
    }
  }

  // console.log('[Case-default]');

  return {
    isTextOptionAvailable: true,
    isAlignmentOptionAvailable: true,
    isSectionsOptionAvailable: true,
    isRotateAndFlipOptionAvailable: true,
    isFillAndLineOptionAvailable: true,
    isMatrixOptionAvailable: false,
    isSeparatorOptionAvailable: false,
    isImageOptionAvailable: false,
    isRectangleShapeOptionAvailable: false,
    isEllipseShapeOptionAvailable: false,
    isGraphicOptionAvailable: false,
    isInsertSymbolAvailable: false
  };
};
